import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import QuestionAndAnswersDataTable from "components/TableContainers/QuestionsAndAnswersDataTable";
import { fetchQuestionsAndAnswersRequest } from "store/actions";

const QuestionAndAnswersTable = ({
  data,
  totalrows,
  loading,
  moduleOptions,
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  searchString,
  setSearchString,
  selectedModule,
  setSelectedModule,
  selectedSortData,
  setSelectedSortData,
}) => {
  const dispatch = useDispatch();

  // ✅ Table Columns
  const columns = useMemo(
    () => [
      {
        header: "Student",
        accessorKey: "studentId",
        showFilter:false,
        cell: ({ row }) => (
          <div>
            <div className="fw-semibold">{row.original?.studentId?.name || "-"}</div>
            <div
              style={{
                color: "#555",
                fontSize: "0.85rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "220px",
              }}
              title={row.original?.studentId?.email}
            >
              {row.original?.studentId?.email || "-"}
            </div>
          </div>
        ),
      },
      {
        header: "Question",
        accessorKey: "question",
         showFilter:false,
        cell: ({ row }) => (
          <div
            style={{
              maxWidth: "280px",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "#222",
            }}
            title={row.original?.question}
          >
            {row.original?.question || "-"}
          </div>
        ),
      },
      {
        header: "Answer",
        accessorKey: "answer",
         showFilter:false,
        cell: ({ row }) =>
          row.original?.answer ? (
            <div
              style={{
                maxWidth: "300px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "#333",
              }}
              title={row.original.answer}
            >
              {row.original.answer}
            </div>
          ) : (
            <span className="badge bg-warning text-dark">Pending</span>
          ),
      },
      {
        header: "Module",
        accessorKey: "moduleId",
        showFilter:false,
        cell: ({ row }) => row.original?.moduleId?.title || "-",
      },
      {
        header: "Lesson",
        accessorKey: "lessonId",
        showFilter:false,
        cell: ({ row }) => row.original?.lessonId?.title || "-",
      },
      {
        header: "Answered By",
        accessorKey: "answeredBy",
        showFilter:false,
        cell: ({ row }) => row.original?.answeredBy?.name || "-",
      },
      {
        header: "Date",
        accessorKey: "updatedAt",
         showFilter:false,
        cell: ({ row }) =>
          new Date(row.original.updatedAt).toLocaleString("en-IN", {
            dateStyle: "medium",
            timeStyle: "short",
          }),
      },
    ],
    []
  );

 

  return (
    <div className="container-fluid">
      <QuestionAndAnswersDataTable
        columns={columns}
        data={data}
        loading={loading}
        totalrows={totalrows}
        moduleOptions={moduleOptions}
        selectedSortData={selectedSortData}
        setSelectedSortData={setSelectedSortData}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        searchString={searchString}
        setSearchString={setSearchString}
        selectedModule={selectedModule}
        setSelectedModule={setSelectedModule}
      />
    </div>
  );
};

export default QuestionAndAnswersTable;
